<template>
    <div>
        <draggable :list="inspectionTestPlan.sections[sectionIndex].tasks" draggable=".draggable" handle=".handle"
                   @change="update();">
            <inspectionTestPlan-task v-for="(task,index) in inspectionTestPlan.sections[sectionIndex].tasks" :key="index" ref="tasks"
                           :task="task" :section="section" :editable="editable" :update="update" :inspectionTestPlan="inspectionTestPlan"></inspectionTestPlan-task>
        </draggable>


        <!-- New Task. -->
        <div class="flex items-center mt-10 mb-1" v-if="editable">
            <div class="w-6 flex-shrink-0">
                <i class="fa fa-plus text-sm text-gray-400"></i>
            </div>
            <div class="w-12">
                <input
                    :placeholder="nextTaskReference()"
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    v-model="newTask.reference"
                >
            </div>
            <div class="flex-1 ml-4">
                <input
                    placeholder="Add a new task..."
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    v-model="newTask.name"
                    @input="addTask"
                >
            </div>
            <div class="w-6 flex-shrink-0 ml-2"></div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    props: {
        sectionIndex: Number,
        inspectionTestPlan: Object,
        section: Object,
        editable: true,
        update: Function,
    },
    data() {
        return {
            newTask: {
                reference: null,
                name: null,
            },
        }
    },
    watch: {
        section: {
            handler(newValue, oldValue) {
                this.$nextTick(() => {
                    this.$refs['tasks'].forEach((task) => {
                        task.$refs['items'].forEach((item) => {
                            item.$refs['autoresizable-textarea'].resizeTextarea({target: item.$refs['autoresizable-textarea'].$el})
                        })
                    })
                })
            },
            deep: true,
        },
    },
    computed: {},
    methods: {
        addTask() {
            this.inspectionTestPlan.sections[this.sectionIndex].tasks.push({
                reference: this.newTask.reference ?? this.nextTaskReference(),
                defaultReference: this.nextTaskReference(),
                name: this.newTask.name,
                items: [],
            });
            this.$nextTick(() => {
                this.$refs.tasks[this.$refs.tasks.length - 1].$refs.name.focus()
                this.newTask.reference = null,
                this.newTask.name = ''
            })
        },
        nextTaskReference() {
            const sectionNumber = this.inspectionTestPlan.sections.indexOf(this.section) + 1
            const taskNumber = this.section.tasks.length + 1
            return `${sectionNumber}.${taskNumber}`
        },
    },
}
</script>
